module.exports = __webpack_public_path__ + "img/top_logo@2x.872765a6.png";